module.exports = __webpack_public_path__ + "static/c14-cb5e2dc8b1a0be5eed78693a9c01ade9.jpg";